import { FlexProps, Flex } from '@chakra-ui/react'

const DropContainer = ({ children, ...props }: FlexProps) => {
  const { color, ...rest } = props
  return (
    <Flex
      width={'100%'}
      flexGrow={1}
      overflow={'hidden'}
      position={'relative'}
      height={['92px', '102px', '116px']}
      {...rest}
    >
      {children}
    </Flex>
  )
}

export default DropContainer
